import React, { useMemo, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { ArrowLeft, Calculator } from 'lucide-react';

const STEUERKLASSEN = [
  { value: 'I', label: 'I (ledig)', factor: 0.64 },
  { value: 'II', label: 'II (Alleinerziehend)', factor: 0.67 },
  { value: 'III', label: 'III (verheiratet, höherer Verdienst)', factor: 0.72 },
  { value: 'IV', label: 'IV (verheiratet, gleich)', factor: 0.65 },
  { value: 'V', label: 'V (verheiratet, niedrigerer Verdienst)', factor: 0.58 },
  { value: 'VI', label: 'VI (zweiter Job)', factor: 0.54 },
];

const GehaltsrechnerResource = () => {
  const [searchParams] = useSearchParams();
  const q = searchParams.toString() ? `?${searchParams.toString()}` : '';
  const [brutto, setBrutto] = useState('3500');
  const [klasse, setKlasse] = useState('I');

  const result = useMemo(() => {
    const b = parseFloat(String(brutto).replace(',', '.')) || 0;
    const row = STEUERKLASSEN.find((k) => k.value === klasse) || STEUERKLASSEN[0];
    const net = Math.round(b * row.factor * 100) / 100;
    return { net, bruttoNum: b };
  }, [brutto, klasse]);

  return (
    <div className="space-y-8">
      <div>
        <Link
          to={q ? `/${q}` : '/'}
          className="inline-flex items-center text-sm font-medium text-hrf-navy hover:text-hrf-navy-800 mb-4"
        >
          <ArrowLeft className="h-4 w-4 mr-1" />
          Zum Dashboard
        </Link>
        <div className="flex items-center gap-3">
          <div className="p-3 bg-hrf-navy/10 rounded-lg">
            <Calculator className="h-8 w-8 text-hrf-navy" />
          </div>
          <div>
            <h1 className="text-3xl font-bold text-hrf-navy">Gehaltsrechner</h1>
            <p className="mt-1 text-gray-600 text-sm">Orientierungswerte – keine steuerliche Beratung</p>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 max-w-xl">
        <label className="block text-sm font-medium text-gray-700 mb-2">Bruttogehalt pro Monat (€)</label>
        <input
          type="text"
          inputMode="decimal"
          value={brutto}
          onChange={(e) => setBrutto(e.target.value)}
          className="w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-900 focus:outline-none focus:ring-2 focus:ring-hrf-navy focus:border-hrf-navy"
        />

        <label className="block text-sm font-medium text-gray-700 mt-6 mb-2">Steuerklasse (vereinfacht)</label>
        <select
          value={klasse}
          onChange={(e) => setKlasse(e.target.value)}
          className="w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-900 bg-white focus:outline-none focus:ring-2 focus:ring-hrf-navy focus:border-hrf-navy"
        >
          {STEUERKLASSEN.map((k) => (
            <option key={k.value} value={k.value}>
              {k.label}
            </option>
          ))}
        </select>

        <div className="mt-8 p-4 bg-hrf-navy/5 rounded-lg border border-gray-100">
          <p className="text-xs text-gray-500 uppercase tracking-wide mb-1">Geschätztes Netto / Monat</p>
          <p className="text-2xl font-semibold text-hrf-navy">
            {result.bruttoNum > 0 ? `${result.net.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €` : '—'}
          </p>
        </div>

        <p className="mt-4 text-xs text-gray-500 leading-relaxed">
          Die Berechnung nutzt pauschale Faktoren (Lohnsteuer, SV, ohne Kirchensteuer-Detail). Für exakte Beträge bitte
          offizielle Rechner oder die Lohnabrechnung heranziehen.
        </p>
      </div>
    </div>
  );
};

export default GehaltsrechnerResource;
